import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { CarouselModule, IconModule, MediaModule } from '@spartacus/storefront';
import { InteractiveCarouselLoadingStrategyService } from './interactive-carousel-loading-strategy.service';
import { InteractiveCarouselComponent } from './interactive-carousel.component';

@NgModule({
  declarations: [InteractiveCarouselComponent],
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
    MediaModule,
    UrlModule,
    I18nModule,
    CarouselModule,
  ],
  exports: [InteractiveCarouselComponent],
  providers: [InteractiveCarouselLoadingStrategyService],
})
export class InteractiveCarouselModule {}
